import type { Radii } from './types';

export const radii: Radii = {
  none: '0px',
  rounded: '6px',
  circle: '50%',
};
